import { Box, Text } from "@chakra-ui/react";
import { CloseNewSVG } from "assets";
import { AbstractModal } from "components";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  time: string;
  onExpired: (iso: string) => void;
  minuteCount?: number;
}

const QuoteDetailsModal = ({ isOpen, onClose, children, onExpired, time, minuteCount }: Props) => {
  return (
    <>
      <AbstractModal
        isOpen={isOpen}
        onClose={onClose}
        isCentered={false}
        closeOnOverlayClick={false}
        _content={{
          maxW: { base: "350px", md: "475px" },
          borderRadius: "20px",
          p: { base: "53px 14px 32px", md: "53px 16px" },
          bg: "#fff",
        }}
      >
        <Box
          pos="absolute"
          top={{ base: "3%", md: "3%" }}
          right={{ base: "6%", md: "5%" }}
          onClick={onClose}
          cursor="pointer"
          _hover={{
            zoom: "1.05",
            transition: "all .5s ease-in",
          }}
        >
          <CloseNewSVG />
        </Box>

        <Box>
          {/* <Box
            bg="#E2F2DA"
            color="#303131"
            fontSize={{ base: "14px", md: "16px" }}
            fontWeight="600"
            padding="10px"
            borderRadius="10px"
            textAlign="center"
            maxWidth={{ base: "225px", md: "244px" }}
            mx="auto"
            alignItems="center"
            justifyContent="center"
            gridGap="4px"
          >
            <QuoteTimer time={time} onExpired={onExpired} />
          </Box> */}

          <Text
            maxW={{ base: "90%", md: "380px" }}
            mx="auto"
            width="100%"
            fontSize={{ base: "14px", md: "16px" }}
            lineHeight={{ base: "22.66px", md: "26.25px" }}
            // margin={{ base: "27px auto", md: "36px auto" }}
            textAlign="center"
          >
            Trade confirmed. You have 2 minutes to complete the order before the quote expires and the conversion rate may change.
          </Text>
        </Box>

        <Box>{children}</Box>
      </AbstractModal>
    </>
  );
};

export default QuoteDetailsModal;
